/**
 * PM12Analytics — measurement wiring for /pro-member-v12 (renders nothing).
 *
 *  - pm12_pricing_view: once, when section#pricing first enters the viewport.
 *  - pm12_cta_click: every [data-pm12-event] link, with plan + location
 *    (location=final_cta on the two §10 plan links, D6).
 * Checkout opened = GA4 automatic page_view on /checkout/membership (D3).
 */

'use client';

import { useEffect } from 'react';
import { pm12Track } from './track';

export default function PM12Analytics() {
  useEffect(() => {
    const pricing = document.getElementById('pricing');
    let io: IntersectionObserver | null = null;
    if (pricing) {
      io = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            pm12Track('pm12_pricing_view');
            io?.disconnect();
          }
        },
        { threshold: 0.15 },
      );
      io.observe(pricing);
    }

    function onClick(e: MouseEvent) {
      const el = (e.target as HTMLElement | null)?.closest<HTMLElement>('[data-pm12-event]');
      if (!el) return;
      const params: Record<string, string> = { cta: el.dataset.pm12Event ?? '' };
      if (el.dataset.pm12Plan) params.plan = el.dataset.pm12Plan;
      if (el.dataset.pm12Location) params.location = el.dataset.pm12Location;
      pm12Track('pm12_cta_click', params);
    }
    document.addEventListener('click', onClick);
    return () => {
      io?.disconnect();
      document.removeEventListener('click', onClick);
    };
  }, []);
  return null;
}
